// extracted by mini-css-extract-plugin
module.exports = {"deviceIcon":"DeviceIcon_deviceIcon__3aMds","white":"DeviceIcon_white__lgE4K"};